
$(document).ready(function () {

    //SetStep Validate and Navigate
    //$("body").on("click", "#HasoForm button", function () {
    if ($("#HasoForm").length > 0) {
        //önce servise bağlanıp taksitleri getirsin
        var _amount = $('#HasoForm input[name="Amount"]').val();
        if (_amount != "") {
            $.ajax({
                type: 'post',
                async: false,
                cache: false,
                url: "/Haso/GetInstallments",
                data: "_amount=" + _amount,
                success: function (x) {
                    if (x.indexOf("Hata:") >= 0) {
                        $("#HasoOdemeDivi").html(x);
                    }
                    else {
                        $("#HasoInstallments").html(x);

                        $("#HasoForm button#btnbasvur").removeClass("hide");
                    }

                }

            });
        }
        else {
            alert("Taksitler için Sipariş Tutarı Gereklidir.");
        }


        $("#HasoForm button#btnbasvur").on("click", function () {

            if ($("#HasoForm input[name='selectedInstallment']:checked").length <= 0) {
                alert("Taksit seçimi yapmalısınız.");
            }
            else {
                if ($("#chcCTOkudum").is(':checked')) {

                    $form = $("#HasoForm");
                    var dt = $("#HasoForm select[name='Years']").val() + '-' + $("#HasoForm select[name='Months']").val() + '-' + $("#HasoForm select[name='Days']").val();
                    $.ajax({
                        type: 'post',
                        async: true,
                        cache: false,
                        beforeSend: function () {
                            $('#HasoForm button').addClass('hide');
                            $('#HasoForm span.bekleyinizSpani').removeClass('hide');
                        },
                        url: "/Haso/HasoToApply",
                        data: $form.serialize() + '&BirthDate=' + dt,
                        success: function (x) {
                            //console.log(x);
                            $('#HasoForm button').removeClass('hide');
                            $('#HasoForm span.bekleyinizSpani').addClass('hide');

                            if (typeof x.ResultCode !== 'undefined') {
                                if (x.ResultCode == 0) {
                                    $("#HasoForm").prepend('<div class="alert alert-success">' + x.ResultMessage + '</div>');
                                }
                                else {
                                    $("#HasoForm").prepend('<div class="alert alert-danger">' + x.ResultMessage + '</div>');
                                }
                            }
                            else {
                                $("#HasoForm").closest(".SingleLineCart").html(x);
                            }

                            setTimeout(function () {
                                $("#HasoForm").find("div.alert").remove();
                            }, 5000);
                        }

                    });
                }
                else {
                    alert("'Sonra Öde' Sözleşmesini Okudum olarak işaretlemelisiniz.");
                }
            }


        });

    }
    $("body").on("click", "#HasoApplyForm button", function () {

        if ($("#HasoApplyForm").length > 0) {
            var sectaksit = $("#HasoApplyForm input[name='selectedInstallment']:checked").val();

            if (sectaksit !== 'undefined') {

                $form = $("#HasoApplyForm");

                $.ajax({
                    type: 'post',
                    async: true,
                    cache: false,
                    url: "/Haso/HasoSendSmsCode",
                    data: $form.serialize(),
                    success: function (x) {
                        //console.log(x);//
                        //if (x.ResultCode == 0) {
                        //    $("#HasoApplyForm").closest(".SingleLineCart").html('<div class="alert alert-success">' + x.ResultMessage + '</div>');
                        //}
                        //else {
                        //    $("#HasoApplyForm").prepend('<div class="alert alert-error">' + x.ResultMessage + '</div>');
                        //}
                        if (typeof x.ResultCode !== 'undefined') {
                            if (x.ResultCode == 0) {
                                $("#HasoApplyForm").prepend('<div class="alert alert-success">' + x.ResultMessage + '</div>');
                            }
                            else {
                                $("#HasoApplyForm").prepend('<div class="alert alert-danger">' + x.ResultMessage + '</div>');
                            }
                        }
                        else {
                            $("#HasoApplyForm").closest(".SingleLineCart").html(x);
                        }

                        setTimeout(function () {
                            $("#HasoApplyForm").find("div.alert").remove();
                        }, 5000);
                    }

                });
            }
            else {
                alert("Taksit seçmelisiniz.");
            }
        }

    });

    $("body").on("click", "#HasoApplyPinCodeForm button", function () {

        if ($("#HasoApplyPinCodeForm").length > 0) {
            var secpinCode = $("#HasoApplyPinCodeForm input[name='pinCode']").val();
            var secdogumYili = $("#HasoApplyPinCodeForm input[name='dogumYili']").val();

            if (secpinCode !== 'undefined' || secpinCode !== '') {
                if (secdogumYili !== 'undefined' || secdogumYili !== '') {


                    $form = $("#HasoApplyPinCodeForm");

                    $.ajax({
                        type: 'post',
                        async: true,
                        cache: false,
                        url: "/Haso/HasoSendPinCode",
                        data: $form.serialize(),
                        success: function (x) {

                            if (typeof x.ResultCode !== 'undefined') {
                                if (x.ResultCode == 0) {
                                    $("#HasoApplyPinCodeForm").prepend('<div class="alert alert-success">' + x.ResultMessage + '</div>');
                                }
                                else {
                                    $("#HasoApplyPinCodeForm").prepend('<div class="alert alert-danger">' + x.ResultMessage + '</div>');
                                }
                            }
                            else {
                                $("#HasoApplyPinCodeForm").closest(".SingleLineCart").html(x);
                            }

                            setTimeout(function () {
                                $("#HasoApplyPinCodeForm").find("div.alert").remove();
                            }, 5000);
                        }

                    });
                }
                else {
                    alert("Doğum yılınızı giriniz.");
                }
            }
            else {
                alert("Telefonunuza gelen Pin kodunu giriniz.");
            }
        }

    });

    $("body").on("click", "#HasoApplyProcessCheckForm button", function () {

        if ($("#HasoApplyProcessCheckForm").length > 0) {

            $form = $("#HasoApplyProcessCheckForm");

            $.ajax({
                type: 'post',
                async: true,
                cache: false,
                url: "/Haso/HasoAskProcess",
                data: $form.serialize(),
                success: function (x) {

                    if (typeof x.ResultCode !== 'undefined') {
                        if (x.ResultCode == 0) {
                            $("#HasoApplyProcessCheckForm").prepend('<div class="alert alert-success">' + x.ResultMessage + '</div>');
                        }
                        else {
                            $("#HasoApplyProcessCheckForm").prepend('<div class="alert alert-danger">' + x.ResultMessage + '</div>');
                        }
                    }
                    else {
                        $("#HasoApplyProcessCheckForm").closest(".SingleLineCart").html(x);
                    }

                    setTimeout(function () {
                        $("#HasoApplyProcessCheckForm").find("div.alert").remove();
                    }, 5000);
                }

            });
        }

    });

    //$("body").on("click", "#HasoApplyInsForm button", function () {

    //    if ($("#HasoApplyInsForm").length > 0) {
    //        var sectaksit = $("#HasoApplyInsForm input[name='selectedInstallment']:checked").val();

    //        if (sectaksit !== 'undefined') {

    //            $form = $("#HasoApplyInsForm");

    //            $.ajax({
    //                type: 'post',
    //                async: true,
    //                cache: false,
    //                url: "/Haso/HasoSendInstallment",
    //                data: $form.serialize(),
    //                success: function (x) {
    //                    //console.log(x);
    //                    //if (x.ResultCode == 0) {
    //                    //    $("#HasoApplyInsForm").closest(".SingleLineCart").html('<div class="alert alert-success">' + x.ResultMessage + '</div>');
    //                    //}
    //                    //else {
    //                    //    $("#HasoApplyInsForm").prepend('<div class="alert alert-error">' + x.ResultMessage + '</div>');
    //                    //}
    //                    if (typeof x.ResultCode !== 'undefined') {
    //                        if (x.ResultCode == 0) {
    //                            $("#HasoApplyInsForm").prepend('<div class="alert alert-success">' + x.ResultMessage + '</div>');
    //                        }
    //                        else {
    //                            $("#HasoApplyInsForm").prepend('<div class="alert alert-error">' + x.ResultMessage + '</div>');
    //                        }
    //                    }
    //                    else {
    //                        $("#HasoApplyInsForm").closest(".SingleLineCart").html(x);
    //                    }

    //                    setTimeout(function () {
    //                        $("#HasoApplyInsForm").find("div.alert").remove();
    //                    }, 5000);
    //                }

    //            });
    //        }
    //        else {
    //            alert("Taksit seçmelisiniz.");
    //        }
    //    }

    //});

    $("body").on("click", "#ReadAgreementHaso", function (e) {

        $("#AgreementModal .modal-body").html($("#AgreementDetailsHaso").html());
        $("#AgreementModal").modal('show');

        return false;
    });
});